export function bySubmittedAt({asc = true}) {
  return ({submittedAt: a}, {submittedAt: b}) => {
    if (new Date(a) > new Date(b)) return asc ? 1 : -1
    if (new Date(a) < new Date(b)) return asc ? -1 : 1
    return 0
  }
}

export function byPosition({asc = true} = {}) {
  return ({question: {position: a}}, {question: {position: b}}) => {
    if (a > b) return asc ? 1 : -1
    if (b > a) return asc ? -1 : 1
    return 0
  }
}

export default {
  byPosition,
  bySubmittedAt
}
